import { formatDateShortMonth, formatDateWithTime, LinkButton } from '@ami/react/core';
import PropTypes from 'prop-types';

const AmiTaskPanelItem = ({ amiTask, onOpenView }) => {
  const { id, title } = amiTask;
  return (
    <li key={id}>
      <div className="row">
        <div className="col-md-5 col-12">
          <div>
            <LinkButton id={id} label={title} onClick={onOpenView.bind(id)} />
          </div>
          <div>{amiTask.type}</div>
          <div>
            {amiTask.associationLines.map((item, index) => (
              <div key={index}>{item}</div>
            ))}
          </div>
        </div>
        <div className="col-md-2 col-6 text-center">
          <div>{amiTask.nameUser}</div>
          <div>Due {formatDateWithTime(amiTask.dueDate)}</div>
          <div className="row">
            <div className='col-12 d-flex justify-content-center'>
              <div className='flex-grow-0 me-2'>
                {amiTask.isDueSoon && (
                  <span className="badge text-bg-warning">Due soon</span>
                )}
                {amiTask.isDueToday && (
                  <span className="badge text-bg-warning">Due today</span>
                )}
                {amiTask.isPastDue && (
                  <span className="badge text-bg-danger">Past due</span>
                )}
              </div>
              <div className='flex-grow-0'>
                { amiTask.preventPoSubmission && amiTask.status === 'Open'  && (
                  <span className="badge text-bg-secondary">Blocks PO Submission</span>
                )}
              </div>
            </div>
          </div>
        </div>
        <div className="col-md-5 col-6 text-end">
          <div>
            <strong>{amiTask.status}</strong>
          </div>
          <div className="created-on">
            {amiTask.created && (
              <div> Created {formatDateWithTime(amiTask.created)}</div>
            )}
          </div>
          <div className="created-on">
            {amiTask.lastUpdated && (
              <div> Last updated {formatDateWithTime(amiTask.lastUpdated)}</div>
            )}
          </div>
        </div>
      </div>
    </li>
  );
};

AmiTaskPanelItem.propTypes = {
  amiTask: PropTypes.any.isRequired,
  onOpenView: PropTypes.func.isRequired,
};

export { AmiTaskPanelItem };

